import { render, staticRenderFns } from "./announcement-form.vue?vue&type=template&id=52ecf976&scoped=true&"
import script from "./announcement-form.vue?vue&type=script&lang=js&"
export * from "./announcement-form.vue?vue&type=script&lang=js&"
import style0 from "./announcement-form.vue?vue&type=style&index=0&id=52ecf976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecf976",
  null
  
)

export default component.exports